// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-bottom-right[data-v-8debdf28]{position:fixed;bottom:80px;right:25px}.is-circle[data-v-8debdf28]{box-shadow:0 2px 10px rgba(51,57,100,.1),0 4px 10px rgba(0,0,0,.2),0 1px 5px rgba(0,0,0,.1);width:56px;height:56px;text-align:center}.is-circle .icon[data-v-8debdf28]{font-size:21px}", ""]);
// Exports
module.exports = exports;
